<template>
<div style="display:inline-block;">
    <ww-open-data :type="type" :openid="openid" :default-text="name||''" v-if="error"/> 
	<span v-else>{{name||''}}</span>
</div>
</template>
<script>
export default {
	data(){
		return{
			error:true
		}
	},
	props: ["type", "openid",'name'],
	created(){
		let Vm = this;
		let _key = 'openid_' + this.openid;
		console.log('created',_key)
		//组件初始化先挂载回调到window对象
		window[_key] = function(openid){
			//如果未opden-data组件获取失败，且是当前openid，展示name
			if(openid == Vm.openid){
				Vm.error = false;
			}
		}
	},
	beforeDestroy(){
		console.log('组件被销毁')
		let _key = 'openid_' + this.openid;
		//销毁防止内存泄漏
		window[_key] = null;
	},
	mounted() {
		var _this = this;
        var _ele = this.$el
		WWOpenData.bind(this.$el);
        if (WWOpenData.checkSession) {
            WWOpenData.checkSession({
                success() {
                    console.log('企业微信服务有登录态')
                },
                fail() {
                    console.error('企业微信服务登录态过期')
                    _ele.innerHTML = _this.name;
                }
            })
        }
        if (WWOpenData.on) {
            WWOpenData.on("error", () => {
                var innerText = ''
                 innerText = _this.name;
                // _ele && (_ele.innerHTML = innerText)
            });
        }
	},
	watch:{
		
	}
};
</script>